import { render, staticRenderFns } from "./default-v2.vue?vue&type=template&id=5871b828&scoped=true&"
import script from "./default-v2.vue?vue&type=script&lang=js&"
export * from "./default-v2.vue?vue&type=script&lang=js&"
import style0 from "./default-v2.vue?vue&type=style&index=0&id=5871b828&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5871b828",
  null
  
)

export default component.exports